import api from './api'
import enums from '@/api/enums'
import siteVersions from '@/app/site-versions/api'
import subjects from '@/app/feedback/subject/api'

export default {
  namespaced: true,
  state: {
    routeKey: 'feedbackId',
    routes: {
      index: 'feedback.index',
      create: 'feedback.create',
      edit: 'feedback.edit'
    },
    table: [
      { code: 'type', type: 'function', get: data => data?.description, sort: true },
      { code: 'locale', type: 'string' },
      { code: 'site_version', type: 'function', get: data => data?.name },
      { code: 'subject', type: 'function', get: data => data?.name },
      { code: 'country', type: 'string' },
      { code: 'city', type: 'string' },
      { code: 'full_name', type: 'string' },
      { code: 'email', type: 'string' },
      { code: 'phone', type: 'string' },
      { code: 'created_at', type: 'datetime', sort: true },
      { code: 'updated_at', type: 'datetime', sort: true }
    ],
    form: [
      { code: 'type', type: 'select', options: [], validation: { required: true, integer: true } },
      { code: 'site_version_id', type: 'select', options: [], validation: { required: true, integer: true } },
      { code: 'subject_id', type: 'select', options: [], validation: { required: true, integer: true } },
      { code: 'country', type: 'text', validation: { required: true } },
      { code: 'city', type: 'text', validation: { required: true } },
      { code: 'locale', type: 'text', validation: { required: true } },
      { code: 'full_name', type: 'text', validation: { required: true } },
      { code: 'email', type: 'text', validation: { required: true } },
      { code: 'phone', type: 'text', validation: { required: true } },
      { code: 'company_name', type: 'text' },
      { code: 'profile', type: 'text' },
      { code: 'message', type: 'textarea', validation: { required: true } },
      { code: 'file', type: 'file' }
    ],
    item: {},
    items: [],
    meta: {},
    page: 1,
    sort: '-id'
  },
  mutations: {
    SET_ITEMS (state, data) {
      state.items = data.data
      state.meta = data.meta
    },
    SET_ITEM (state, data) {
      state.item = {
        id: data.id || null,
        type: data.type?.value || null,
        locale: data.locale || null,
        site_version_id: data.site_version?.id || null,
        subject_id: data.subject?.id || null,
        country: data.country || null,
        city: data.city || null,
        full_name: data.full_name || null,
        email: data.email || null,
        phone: data.phone || null,
        company_name: data.company_name || null,
        profile: data.profile || null,
        message: data.message || null,
        file_old: data.file || null,
        file: null,
        file_delete: null
      }
    },
    SET_SELECT_OPTIONS (state, { code, options }) {
      state.form.find(item => item.code === code).options = options
    },
    SET_SORT (state, field) {
      state.sort = state.sort === field ? `-${field}` : field
    },
    SET_PAGE (state, page) {
      state.page = page
    }
  },
  actions: {
    async fetchItems ({ commit, state }) {
      const { data } = await api.index({
        'sort': state.sort,
        'page[number]': state.page
      })

      commit('SET_ITEMS', data)
    },
    clearItems ({ commit }) {
      commit('SET_ITEMS', {})
    },
    async fetchItem ({ commit }, { route }) {
      const { data: { data } } = await api.show(route.params.feedbackId)

      commit('SET_ITEM', data)
    },
    clearItem ({ commit }) {
      commit('SET_ITEM', {})
    },
    async fetchEnums ({ commit }) {
      const { data } = await enums.index()

      const options = data.feedbackTypes?.map(item => ({
        value: item.value,
        text: item.description
      }))

      commit('SET_SELECT_OPTIONS', { code: 'type', options })
    },
    async fetchSiteVersions ({ commit }) {
      const { data: { data } } = await siteVersions.index({
        'sort': 'weight',
        'page[all]': true
      })

      const options = data.map(item => ({
        value: item.id,
        text: item.name
      }))

      commit('SET_SELECT_OPTIONS', { code: 'site_version_id', options })
    },
    async fetchFeedbackSubjects ({ commit }) {
      const { data: { data } } = await subjects.index({
        'sort': 'weight',
        'page[all]': true
      })

      const options = data.map(item => ({
        value: item.id,
        text: item.name
      }))

      commit('SET_SELECT_OPTIONS', { code: 'subject_id', options })
    },
    async createItem ({ commit }, { form }) {
      const { data: { data } } = await api.store(form)

      commit('SET_ITEM', data)
    },
    async updateItem ({ commit }, { route, form }) {
      const { data: { data } } = await api.update(route.params.feedbackId, form)

      commit('SET_ITEM', data)
    },
    async deleteItem ({ commit }, { id }) {
      await api.destroy(id)
    }
  }
}
